import styled from 'styled-components';
import { backgrounds } from 'polished';

interface IContainer {
 
}

export const Container = styled.div<IContainer>`
  position: relative;
  cursor: pointer;
 
  transition: background 3s;

 
  background-size: contain;

  width: 100%;
 
  
`;
